exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-edit[_v-3bf983a9]{top:0}.profile-edit .mdl-button.mdl-button--icon[_v-3bf983a9]{font-size:32px;width:48px;height:48px}.profile-edit .mdl-button.mdl-button--icon .material-icons[_v-3bf983a9]{color:#f19100;font-size:32px;left:20px;top:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-3bf983a9&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/forms/ProfileEditForm.vue
// module id = 303
// module chunks = 0